import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
// import { useTranslation } from "react-i18next";

import { createLanguages, getURL } from "./utilities";
import classes from "./Preview.module.scss";
import Icon from "../../../../../../atoms/Icon";
import cs from "classnames";
import { observer } from "mobx-react-lite";
import { StoreContext } from "../../../../../../../contexts";
import Loader from "../../../../../../atoms/Loader";
import { APPLICATION_ROUTES } from "../../../../../../../constants";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import { Authorization } from "../../../../../../organisms/RestrictionModal/RestrictionModal";
import { useModal } from "../../../../../../../hooks";
import { getDetails } from "../../../../../../atoms/Preview/utilities";
import { isMobileDevice } from "../../../../../../../utilities/helpers";

const Preview = observer(
  ({
    locales,
    categories,
    questions,
    tags,
    file,
    holiday,
    placeholder,
    internal_id,
    projectType,
    onSelect,
    freeAccess,
  }) => {
    // const {
    //   // t,
    //   i18n: { language },
    // } = useTranslation();

    const { playlist, authorization, partnership } = useContext(StoreContext);

    const downloadFile = (url) => {
      window.open(url);
    };

    // const details = getDetails(language, locales);
    const details = getDetails(locales);
    const languages = createLanguages(locales);
    const showModal = useModal();

    const [descriptionShown, setDescriptionShown] = useState(false);
    console.log(projectType, "project");
    return (
      <div
        className={cs(classes.container, isMobile ? classes.previewMobile : "")}
      >
        <div
          className={cs(
            classes.preview,
            projectType == "illuminate" ? classes.illuminatePreview : ""
          )}
          role="button"
          style={{
            backgroundImage: `url(${details.thumbnail || placeholder})`,
          }}
        >
          <div
            onClick={() => {
              playlist.setCurrentPlayingVideoId(details.id);
              console.log("Details", details);
              onSelect({
                end: details.end_time,
                start: details.start_time,
                url: getURL(details.link, { start: details.start_time }),
                name: details.name,
                description: details.description,
                number: details.number,
                categories: categories,
                questions: questions,
                tags: tags,
                holiday: holiday,
                date: details.created_at,
                file: file,
                internal_id: internal_id,
                info: {
                  projectType: projectType,
                },
              });
            }}
            className={cs(classes.playerControlWrapper)}
          >
            <Icon
              className={cs(
                classes.playerPlay,
                projectType == "illuminate" ? classes.illuminatePlayerPlay : ""
              )}
              name="player-play"
            />
            {details.duration_formatted && (
              <span className={cs(classes.videoTime)}>
                {details.duration_formatted}
              </span>
            )}
          </div>

          {file && !isMobileDevice() && (
            <div
              onClick={() => {
                if (authorization.isUserMember) {
                  downloadFile(file);
                } else {
                  if (
                    !location.pathname.includes(
                      APPLICATION_ROUTES.LIBRARY_PROECTED
                    )
                  ) {
                    playlist.setCurrentPlayingVideoId(details.id);
                    onSelect({
                      end: details.end_time,
                      start: details.start_time,
                      url: getURL(details.link, { start: details.start_time }),
                      name: details.name,
                      description: details.description,
                      number: details.number,
                      categories: categories,
                      questions: questions,
                      tags: tags,
                      holiday: holiday,
                      date: details.created_at,
                      file: details.file,
                      internal_id: internal_id,
                      info: {
                        projectType: projectType,
                      },
                    });
                  }
                }
              }}
              className={cs(classes.downloadButton)}
            >
              <Icon name="pdf" />
            </div>
          )}

          <div className={cs(classes.watchlistButton)}>
            {playlist.loadingIds.includes(details.id) ? (
              <Loader />
            ) : (
              <Icon
                onClick={() => {
                  if (authorization.isAuthenticated) {
                    if (!authorization.isUserMember && !freeAccess) {
                      showModal.onOpen();
                      return;
                    }
                  }

                  if (authorization.isAuthenticated) {
                    if (authorization.isUserMember || freeAccess) {
                      playlist.handleAddDelete(details.id);
                    } else {
                      if (
                        !location.pathname.includes(
                          APPLICATION_ROUTES.LIBRARY_PROECTED
                        )
                      ) {
                        playlist.setCurrentPlayingVideoId(details.id);
                        onSelect({
                          end: details.end_time,
                          start: details.start_time,
                          url: getURL(details.link, {
                            start: details.start_time,
                          }),
                          name: details.name,
                          description: details.description,
                          number: details.number,
                          categories: categories,
                          questions: questions,
                          tags: tags,
                          holiday: holiday,
                          date: details.created_at,
                          file: details.file,
                          internal_id: internal_id,
                          info: {
                            projectType: projectType,
                          },
                        });
                      }
                    }
                  }
                }}
                title={
                  !authorization.isAuthenticated
                    ? "Please sign in to add videos to Playlist"
                    : ""
                }
                color="primary"
                cursorPointer={true}
                name={
                  authorization.isAuthenticated &&
                  playlist.videoExists(details.id)
                    ? "exit"
                    : "watchlist-button"
                }
              />
            )}
          </div>
        </div>

        <div className={classes.details}>
          {isMobile ? (
            <MobileView>
              <div className={classes.videoHeader}>
                <h1>
                  <div>
                    <strong>{details.name}</strong>
                  </div>
                  <span className={classes.videoDetails}>
                    #{details.number}
                    {categories.length > 0 ? <i></i> : null}
                    {categories.length
                      ? categories.map((category) => {
                          return category.name_hebrew;
                        })
                      : null}
                  </span>
                </h1>

                {details.description && (
                  <Icon
                    onClick={() => {
                      setDescriptionShown(!descriptionShown);
                    }}
                    name={descriptionShown ? "arrow-dropup" : "arrow-dropdown"}
                  />
                )}
              </div>
              <div className={cs(descriptionShown ? "d-block" : "d-none")}>
                {details.description}
              </div>
            </MobileView>
          ) : (
            <BrowserView>
              <p className={classes.title}>
                <span>#{details.number} | </span>
                <strong>{details.name}</strong>
              </p>
            </BrowserView>
          )}

          <div className={classes.languageViewsContainer}>
            {!isMobile ? (
              <BrowserView>
                <ul className={classes.languages}>
                  {languages.map((item, index) => (
                    <li className={classes.item} key={`${item.link}${index}`}>
                      <button
                        className={classes.button}
                        onClick={() => {
                          playlist.setCurrentPlayingVideoId(item.id);
                          onSelect({
                            end: item.end_time,
                            start: item.start_time,
                            url: getURL(item.link, { start: item.start_time }),
                            name: item.name,
                            description: item.description,
                            number: item.number,
                            categories: categories,
                            questions: questions,
                            tags: tags,
                            holiday: holiday,
                            date: item.created_at,
                            file: file,
                            internal_id: internal_id,
                            info: {
                              projectType: projectType,
                            },
                          });
                        }}
                      >
                        {item.language}
                      </button>
                    </li>
                  ))}
                </ul>
              </BrowserView>
            ) : null}
          </div>
        </div>
        <>
          <Authorization
            popup={showModal}
            authorization={authorization}
            partnership={partnership}
          />
        </>
      </div>
    );
  }
);

Preview.propTypes = {
  id: PropTypes.string.isRequired,
  locales: PropTypes.shape({
    // en: PropTypes.shape({
    //   link: PropTypes.string.isRequired,
    // }),
  }).isRequired,
  placeholder: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default React.memo(Preview);
